import React from "react";
import { Modal } from "react-bootstrap";

import { commonErr } from "../common/errors";
import { pickupTrip } from "../../model/car";

export default class PickupTrip extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			step: 0, //0 confirm 1: reject trip
			errMsg: "",
			cancelReasons: null,
			ip_cancel_reason: "",
			ip_comment: "",
		};
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	goToConfirm = () => {
		this.setState({
			step: 0,
			err: commonErr.INNIT,
		});
	};

	getTrip = () => {
		this.props.getTrip(this.props.trip.id);
	};

	finish = () => {
		this.props.hideModal();
		this.setState({
			step: 0,
			err: commonErr.INNIT,
		});
		this.getTrip();
	};

	action = () => {
		const self = this;
		pickupTrip(this.props.trip.id).then(function (resp) {
			self.setState({
				step: 1,
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
			});
		});
	};

	render() {
		var content;
		var isSD = this.props.trip.serviceType === 1;
		if (this.state.step === 1) {
			if (this.state.err >= commonErr.SUCCESS) {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">Hệ thống đã cập nhật.</p>
						<div className="wrap-btn">
							<a className="btn btn-primary btn--m" onClick={this.finish}>
								Hoàn tất
							</a>
						</div>
					</div>
				);
			} else {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">
							{this.state.err === -15000
								? `Không thể ${isSD ? "giao xe" : "đón khách"} trước chuyến đi 6 tiếng.`
								: this.state.errMsg}
						</p>
						<div className="wrap-btn">
							<a className="btn btn-primary btn--m" onClick={this.goToConfirm}>
								Thử lại
							</a>
						</div>
					</div>
				);
			}
		} else {
			content = (
				<div className="modal-confirm-body">
					<p className="font-14">Bạn đã {isSD ? "giao xe cho khách" : "đón khách"}?</p>
					<div className="wrap-btn">
						<a className="btn btn-primary btn--m" onClick={this.action}>
							Xác nhận
						</a>
					</div>
				</div>
			);
		}

		return (
			<Modal show={this.props.show} onHide={this.finish} dialogClassName="modal-s modal-confirm">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Xác nhận {isSD ? "giao xe" : "đón khách"}</h5>
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}
